import { useTranslate } from 'react-admin';
import ActionReportsList from './ActionReportsList';
import ActionReportsShow from './ActionReportsShow';
import { ACTION_REPORTS } from '~/utils/constants/resources';

const resource = ACTION_REPORTS;

export const useTranslateActionReports = () => {
  const translate = useTranslate();
  return (key: string) => translate(`resources.${resource}.fields.${key}`);
};

export default {
  list: ActionReportsList,
  show: ActionReportsShow,
};
